import { defineStore } from "pinia";

export const useStore = defineStore("main", {
  state: () => {
    return {
      device: null,
      init: "",
      nameList: [],
      eventList: [],
      allMacroPacket: {},

      deviceName: "",

      indexData: "",
      changeSetting: "",
      keyData: "",
      deviceList: [],
      deviceCollections: {},
      languageValue: "zh",
      saveMouseVersion: "0.0.0",
      saveFirmwareVersion: "0.0.0",
      currentMouse: "",
      appRNG: [],
      appUpdateData: [],
      updatePercentage: 0,
      mouseData: [],
      dfuData: [],
      dfuData1: [],
    };
  },

  actions: {
    saveDeviceName(name) {
      this.deviceName = name;
    },
    getDfuData1(value) {
      this.dfuData1 = value;
    },
    getDfuData(value) {
      this.dfuData = value;
    },
    getMouseData(value) {
      this.mouseData = value;
    },
    getUpdatePercentage(value) {
      this.updatePercentage = value;
    },
    getAppUpdateData(value) {
      this.appUpdateData = value;
    },
    getAppRNG(value) {
      this.appRNG = value;
    },
    getLocalValue(name, value) {
      this[name] = value;
    },
    setCurrentMouse(value) {
      this.currentMouse = value;
    },
    saveDevice(value) {
      this.device = value;
    },
    initData(value) {
      this.init = value;
    },

    macroName(value) {
      this.nameList.push(value);
    },
    updateMacroName(index, type, value) {
      this.nameList[index][type] = value;
    },
    deleteMacroName(index) {
      this.nameList.splice(index, 1);
      this.eventList.splice(index, 1);
    },
    macroEvent(value) {
      this.eventList.push(value);
    },
    deleteEvent(row, column) {
      this.eventList[row].splice(column, 1);
    },
    updateEvent(nameIndex, eventIndex, value, desc) {
      this.eventList[nameIndex][eventIndex].value = value;
      this.eventList[nameIndex][eventIndex].desc = desc;
    },
    insertEvent(nameIndex, eventIndex, item) {
      const obj = {
        ...item,
        index: this.eventList[nameIndex].length,
      };
      if (eventIndex === -1) {
        this.eventList[nameIndex].push(obj);
      } else {
        this.eventList[nameIndex].splice(eventIndex + 1, 0, obj);
      }
    },

    addPacket(key, value) {
      this.allMacroPacket[key] = value;
    },
    clearPacket() {
      this.allMacroPacket = {};
    },
    deletePacket(key) {
      delete this.allMacroPacket[key];
    },
    addDpi(value) {
      this.indexData = value;
    },
    getChangeSetting(value) {
      this.changeSetting = value;
    },
    getKeyData(value) {
      this.keyData = value;
    },
    addDevice(value) {
      const arr = [];
      for (let i = 0; i < this.deviceList.length; i++) {
        arr.push(this.deviceList[i].value);
      }
      if (arr.indexOf(value) === -1) {
        this.deviceList = [
          ...this.deviceList,
          {
            label: value,
            value: value,
          },
        ];
      }
    },
    addDeviceCollections(key, value) {
      this.deviceCollections = {
        ...this.deviceCollections,
        [key]: value,
      };
    },
    clearDeviceCollections() {
      this.deviceCollections = {};
      this.deviceList = [];
    },

    setLanguageValue(value) {
      this.languageValue = value;
    },
    setMouseVersion(value) {
      this.saveMouseVersion = value;
    },
    setFirmwareVersion(value) {
      this.saveFirmwareVersion = value;
    },
  },
});
